import { Link } from '@tanstack/react-router'
import { useQuery } from '@tanstack/react-query'
import { PanelLeftClose, PanelLeftOpen } from 'lucide-react'
import { navItems } from './nav-items'
import { useFeatureFlag } from '@shared/feature-flags/useFeatureFlag'
import { useReferralAccess } from '@features/referrals/api/referrals'
import { recuperaAiStatusQuery } from '@features/recupera-ai'
import { collapseButton, nav, navItem, navLabel, sidebar } from './AppShell.css'

type SidebarProps = {
  collapsed: boolean
  onCollapsedChange: (next: boolean) => void
}

export function Sidebar({ collapsed, onCollapsedChange }: SidebarProps) {
  const referralsEnabled = useFeatureFlag('referralProgram')
  const recuperaAiEnabled = useFeatureFlag('recuperaAi')
  const membersAreaEnabled = useFeatureFlag('areaDeMembros')
  const access = useReferralAccess()
  const recuperaStatus = useQuery({ ...recuperaAiStatusQuery(), enabled: recuperaAiEnabled })
  const recuperaAiActive =
    recuperaAiEnabled &&
    recuperaStatus.data?.is_active === true &&
    (recuperaStatus.data?.active_product_count ?? 0) > 0
  const ToggleIcon = collapsed ? PanelLeftOpen : PanelLeftClose

  return (
    <aside className={sidebar} data-collapsed={collapsed ? 'true' : 'false'} data-testid="sidebar">
      <nav className={nav}>
        {navItems
          .filter((item) => {
            if (item.to === '/area-membros') return membersAreaEnabled
            if (item.to === '/indicacoes') {
              return referralsEnabled && access.data?.enabled === true && !access.isError
            }
            return true
          })
          .filter((item) => item.to !== '/recupera-ai' || recuperaAiActive)
          .map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={navItem}
              title={collapsed ? item.label : undefined}
              aria-label={collapsed ? item.label : undefined}
            >
              <item.icon size={18} />
              {collapsed ? null : <span className={navLabel}>{item.label}</span>}
            </Link>
          ))}
      </nav>
      <button
        type="button"
        className={collapseButton}
        aria-label={collapsed ? 'Expandir menu' : 'Recolher menu'}
        aria-expanded={!collapsed}
        title={collapsed ? 'Expandir menu' : undefined}
        onClick={() => onCollapsedChange(!collapsed)}
      >
        <ToggleIcon size={18} />
        {collapsed ? null : <span className={navLabel}>Recolher</span>}
      </button>
    </aside>
  )
}
